import { MatchApplyStatusType, MatchResponseType } from 'consts/_v2/match/MatchType';
import { IPageable } from 'interfaces/rqrs/IPages';

// Interface for the matching status
export enum IMatchPositionType {
  ALIM_TALK = 'ALIM_TALK',
  MATCH_INTERVIEW_OFFER = 'MATCH_INTERVIEW_OFFER',
  MATCH_OFFER = 'MATCH_OFFER',
  HDOT_X_OFFER = 'HDOT_X_OFFER',
}

export interface IMatchingStatusDto {
    matchingSn: number;
    companySn: number;
    companyName: string;
    companyLogoUrl: string;
    positionSn: number | null;
    positionTitle: string | null;
    offerReceivedDateTime: string;
    matchingStatusLastModifiedDateTime: string;
    statusType: MatchApplyStatusType;
    responseType: MatchResponseType;
    decisionDueDateTime: string; // 응답 마감 기한
    readYn: boolean;
    likeYn: boolean; // 관심기업 여부
    positionType: IMatchPositionType;
    proposalTitle: string | null;
  }

export interface IMatchingStatusListRs extends IPageable {
    matchingList: IMatchingStatusDto[];
  }
